import styled from "@emotion/styled";

export const WeeklyBarChartSvg = styled.svg`
  width: 100%;
  height: 100%;

  .hour-tick {
    stroke: var(--app-color-primary);
  }

  .minute-tick {
    stroke: var(--app-color-primary);
  }

  .label {
    fill: var(--f7-text-color);
  }

  .duration {
    fill: var(--f7-text-color);
  }

  .center-monitor {
    fill: var(--app-color-primary);
  }

  .digital-clock {
    fill: var(--app-color-white);
  }

  .clock-hand-thin {
    stroke: var(--app-color-primary);
  }

  .clock-hand-thick {
    stroke: var(--app-color-primary);
  }

  .segment-boundary {
    stroke: var(--app-color-white);
  }

  .bad {
    fill: var(--app-color-bad);
  }

  .education {
    fill: var(--app-color-education);
  }

  .family {
    fill: var(--app-color-family);
  }

  .good {
    fill: var(--app-color-good);
  }

  .life {
    fill: var(--app-color-life);
  }

  .other {
    fill: var(--app-color-other);
  }

  .primary {
    fill: var(--app-color-primary);
  }

  .private {
    fill: var(--app-color-private);
  }

  .sleep {
    fill: var(--app-color-sleep);
  }

  .unset {
    fill: var(--app-color-unset);
  }

  .work {
    fill: var(--app-color-work);
  }
`;
